import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./DateSelectStyle.css";
export default function DateSelect(props) {
  const [date, setDate] = useState(props.defaultDate);
  return (
    <div className="py-2 ">
      <div>{props.title}</div>
      <DatePicker
        className=""
        selected={date}
        minDate={new Date()}
        onChange={(date) => {
          setDate(date);

          if (date == null) {
            props.setParentDate("");
            return;
          }
          let searchDate = date.getFullYear();
          let searchMonth = date.getMonth() + 1;

          if (searchMonth < 10) {
            searchDate += "-0" + searchMonth;
          } else {
            searchDate += "-" + searchMonth;
          }

          if (date.getDate() < 10) {
            searchDate += "-0" + date.getDate();
          } else {
            searchDate += "-" + date.getDate();
          }
          props.setParentDate(searchDate);
        }}
      />
    </div>
  );
}
